"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChangeLog = void 0;
const query_string_1 = __importDefault(require("query-string"));
const api_1 = require("@/services/api");
const ENDPOINT = "/tracking";
function getChangeLog(pageIndex, pageSize, filter) {
    const paginationParams = query_string_1.default.stringify({ pageIndex, pageSize });
    const endpoint = `${ENDPOINT}?filter[${filter.name}]=${filter.value}&${paginationParams}&order[createdAt]=desc`;
    return api_1.axiosInstance
        .get(endpoint)
        .then((response) => {
        return response.data.rows;
    })
        .catch((error) => {
        throw new Error(`[Tracking Error]: ${error}`);
    });
}
exports.getChangeLog = getChangeLog;
